export default "__VITE_ASSET__BudDiw$C__"